import React from "react";
import { money, precioDe, zonaVendible } from "./boleteraHelper";

/*
  Destinos agrupados por zona, cada una con su color.
  Una zona sin tarifa para el origen elegido se muestra deshabilitada y explica por qué:
  bloquear la venta es preferible a cobrar un precio inventado.
*/
const ZonaGrid = ({ catalogo, zonaOrigenId, seleccion, onPick }) => {
  const zonas = catalogo?.zonas ?? [];

  if (!zonas.length) {
    return (
      <div className="text-center text-muted py-4" style={{ fontSize: "12.5px" }}>
        Ninguna parada de este ramal tiene zona asignada, así que no hay destinos que cobrar.
        Pide a tu analista que configure las zonas de la ruta.
      </div>
    );
  }

  return (
    <div>
      {zonas.map((zona) => {
        const vendible = zonaVendible(catalogo, zona, zonaOrigenId);
        const desde = (catalogo.tipos ?? [])
          .map((t) => precioDe(catalogo, zona, t, zonaOrigenId))
          .filter((p) => p != null);

        return (
          <div key={zona.id} className="boletera-zona">
            <div className="boletera-zona-head">
              <span className="boletera-zona-dot" style={{ background: zona.color }} />
              <span style={{ fontWeight: 600, fontSize: "13.5px" }}>{zona.nombre}</span>
              <span style={{ flex: 1 }} />
              <span style={{ fontSize: "11.5px", color: "#777a89" }}>
                {vendible ? `desde ${money(Math.min(...desde))}` : "sin tarifa"}
              </span>
            </div>

            <div className="boletera-geos">
              {zona.geocercas.map((geo) => (
                <button
                  key={geo.id}
                  type="button"
                  className={`boletera-geo${seleccion?.geocerca?.id === geo.id ? " is-selected" : ""}`}
                  style={{ borderColor: seleccion?.geocerca?.id === geo.id ? zona.color : undefined }}
                  disabled={!vendible}
                  title={vendible ? geo.nombre : "Sin tarifa configurada para este trayecto"}
                  onClick={() => onPick(zona, geo)}
                >
                  {geo.nombre}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ZonaGrid;
